import { createFileRoute, Link } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, MapPin, Briefcase, Heart, Laptop, Users, Globe } from 'lucide-react';

export const Route = createFileRoute('/careers')({
  component: CareersPage,
});

const benefits = [
  { icon: Heart, title: 'Health & Wellness', description: 'Comprehensive health insurance' },
  { icon: Laptop, title: 'Remote First', description: 'Work from anywhere' },
  { icon: Users, title: 'Team Events', description: 'Regular team gatherings' },
  { icon: Globe, title: 'Global Team', description: 'Diverse, international team' },
];

const openPositions = [
  { title: 'Senior Full-Stack Engineer', department: 'Engineering', location: 'Remote', type: 'Full-time' },
  { title: 'ML/AI Engineer', department: 'Engineering', location: 'Remote', type: 'Full-time' },
  { title: 'Product Designer', department: 'Design', location: 'Remote', type: 'Full-time' },
];

function CareersPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="mb-4">Careers</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Join Our Team</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Help us build the future of developer productivity.
            </p>
          </div>
          <section className="mb-24">
            <h2 className="text-2xl font-bold text-center mb-8">Why Join ForgeNetwork?</h2>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
              {benefits.map((benefit) => {
                const Icon = benefit.icon;
                return (
                  <Card key={benefit.title}>
                    <CardHeader className="text-center">
                      <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-4">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <CardTitle className="text-lg">{benefit.title}</CardTitle>
                      <CardDescription>{benefit.description}</CardDescription>
                    </CardHeader>
                  </Card>
                );
              })}
            </div>
          </section>
          <section>
            <h2 className="text-2xl font-bold text-center mb-8">Open Positions</h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {openPositions.map((position) => (
                <Card key={position.title} className="hover:shadow-md transition-shadow">
                  <CardContent className="py-6">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div>
                        <h3 className="font-semibold text-lg">{position.title}</h3>
                        <div className="flex flex-wrap items-center gap-2 mt-1 text-sm text-muted-foreground">
                          <span className="flex items-center gap-1"><Briefcase className="h-4 w-4" />{position.department}</span>
                          <span className="flex items-center gap-1"><MapPin className="h-4 w-4" />{position.location}</span>
                          <Badge variant="outline">{position.type}</Badge>
                        </div>
                      </div>
                      <Button variant="outline" asChild>
                        <Link to="/contact" search={{ type: 'general' }}>Apply<ArrowRight className="ml-2 h-4 w-4" /></Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
